import React from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import {
  logout,
  getAdminEmail,
  getRole,
  canManageProducts,
  canManageTeam,
} from "../../auth";
import styles from "./AdminNav.module.css";

const AdminNav = () => {
  const navigate = useNavigate();
  const role = getRole();

  const handleLogout = () => {
    logout();
    navigate("/paulvictor");
  };

  const linkClass = ({ isActive }) =>
    isActive ? styles.linkActive : styles.link;

  return (
    <nav className={styles.bar}>
      <Link to="/" className={styles.wordmark}>
        LORMAMI
      </Link>
      <div className={styles.links}>
        {canManageProducts() && (
          <NavLink to="/admin-dashboard" className={linkClass}>
            Add Product
          </NavLink>
        )}
        <NavLink to="/all-item" className={linkClass}>
          All Products
        </NavLink>
        <NavLink to="/admin-categories" className={linkClass}>
          Types
        </NavLink>
        <NavLink to="/admin-orders" className={linkClass}>
          Orders
        </NavLink>
        <NavLink to="/admin-discounts" className={linkClass}>
          Discounts
        </NavLink>
        <NavLink to="/admin-delivery" className={linkClass}>
          Delivery
        </NavLink>
        <NavLink to="/admin-images" className={linkClass}>
          Images
        </NavLink>
        <NavLink to="/admin-community" className={linkClass}>
          Community
        </NavLink>
        {canManageTeam() && (
          <NavLink to="/admin-team" className={linkClass}>
            Team
          </NavLink>
        )}
      </div>
      <span className={styles.email}>{getAdminEmail()}</span>
      {role && <span className={styles.roleBadge}>{role}</span>}
      <button type="button" className={styles.logout} onClick={handleLogout}>
        Log out
      </button>
    </nav>
  );
};

export default AdminNav;
